var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4863 3.30783H4.83141C4.59496 3.30783 4.40332 3.11619 4.40332 2.87975C4.40332 2.6433 4.59496 2.45166 4.83141 2.45166H12.4863C12.7227 2.45166 12.9144 2.6433 12.9144 2.87975C12.9144 3.11619 12.7227 3.30783 12.4863 3.30783Z",
    fill: "#F1935C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6334 5.71652H4.83141C4.59496 5.71652 4.40332 5.52488 4.40332 5.28844C4.40332 5.05199 4.59496 4.86035 4.83141 4.86035H10.6334C10.8698 4.86035 11.0615 5.05199 11.0615 5.28844C11.0615 5.52488 10.8698 5.71652 10.6334 5.71652Z",
    fill: "#F1935C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78078 8.12473H4.83141C4.59496 8.12473 4.40332 7.93309 4.40332 7.69664C4.40332 7.46019 4.59496 7.26855 4.83141 7.26855H8.78078C9.01723 7.26855 9.20887 7.46019 9.20887 7.69664C9.20887 7.93309 9.01723 8.12473 8.78078 8.12473Z",
    fill: "#F1935C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92803 10.5334H4.83141C4.59496 10.5334 4.40332 10.3418 4.40332 10.1053C4.40332 9.86889 4.59496 9.67725 4.83141 9.67725H6.92789C7.16433 9.67725 7.35597 9.86889 7.35597 10.1053C7.35597 10.3418 7.16447 10.5334 6.92803 10.5334Z",
    fill: "#F1935C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73082 10.5336C1.49437 10.5336 1.30273 10.342 1.30273 10.1056V2.87975C1.30273 2.6433 1.49437 2.45166 1.73082 2.45166C1.96727 2.45166 2.15891 2.6433 2.15891 2.87975V10.1056C2.15891 10.3421 1.96727 10.5336 1.73082 10.5336Z",
    fill: "#F1935C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73073 10.5334C1.61714 10.5334 1.50827 10.4883 1.42793 10.408L0.196611 9.17654C0.029515 9.0093 0.029515 8.73833 0.196611 8.57123C0.363707 8.40399 0.634829 8.40399 0.802067 8.57123L1.73073 9.49989L2.65953 8.57123C2.82663 8.40399 3.09775 8.40399 3.26485 8.57123C3.43208 8.73833 3.43208 9.00945 3.26485 9.17654L2.03339 10.408C1.95319 10.4883 1.84431 10.5334 1.73073 10.5334Z",
    fill: "#F1935C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescending);
export default __webpack_public_path__ + "static/media/descending.167edb24e786552efd90e09840dc0489.svg";
export { ForwardRef as ReactComponent };